import React from "react";
import moment from "moment";
import { CustomCopyToClipboard } from "../../../../Components";
import { AEDIcon, CircleIcon } from "../../../../assets/icons";
import { Box } from "@material-ui/core";
import { formatNumberWithCommas } from "../../../../Helper";

const CommissionTableHeaderData = ({ isDarkMode = false }) => [
  {
    id: 1,
    minWidth: 200,
    headerName: "Transaction ID",
    field: "transactionID",
    fieldType: "text",
    displayPath: "transactionId",
    isDefaultFilterColumn: true,
    fieldKey: "transactionId",
    formFieldTitle: "Transaction ID",
    disableColumnMenu: true,
    searchKey: "Transaction ID",
    renderCell: (item) => {
      return (
        <CustomCopyToClipboard
          data={item?.row?.transactionID}
          childrenData={`#${item?.row?.transactionID}`}
        />
      );
    },
  },
  {
    id: 2,
    minWidth: 200,
    headerName: "Deal Status",
    field: "dealStatus",
    fieldType: "text",
    displayPath: "dealStatus",
    isDefaultFilterColumn: true,
    fieldKey: "dealStatus",
    formFieldTitle: "Deal Status",
    disableColumnMenu: true,
    searchKey: "Deal Status",
    renderCell: (item) => {
      const statusFillColor = ["#667085", "#2E90FA", "#17B26A"];
      const statusTextColor = ["#344054", "#175CD3", "#067647"];
      const dealStatus = {
        1: {
          color: statusFillColor[0],
          colorText: statusTextColor[0],
          text: "Draft",
        },
        2: {
          color: statusFillColor[1],
          colorText: statusTextColor[1],
          text: "Posted",
        },
        3: {
          color: statusFillColor[2],
          colorText: statusTextColor[2],
          text: "Approved",
        },
      };
      const Icon = () => (
        <CircleIcon
          viewBox="-14 -4 24 24"
          fill={dealStatus[item?.row?.dealStatus]?.color}
          style={{ marginRight: "8px", marginTop: "3px" }}
        />
      );
      return (
        <Box display={"flex"} marginLeft={"-14px"}>
          {dealStatus[item?.row?.dealStatus] && <Icon />}

          <label
            style={{
              fontWeight: 500,
              fontSize: "14px",
              display: "flex",
              alignItems: "center",

              color: dealStatus[item?.row?.dealStatus]?.colorText,
            }}
          >
            {dealStatus[item.row.dealStatus]?.text || "--"}
          </label>
        </Box>
      );
    },
  },
  {
    id: 3,
    minWidth: 200,
    headerName: "Transaction Status",
    field: "transactionStatus",
    fieldType: "text",
    displayPath: "transactionStatus",
    isDefaultFilterColumn: true,
    fieldKey: "transactionStatus",
    formFieldTitle: "Transaction Status",
    disableColumnMenu: true,
    searchKey: "Transaction Status",
    renderCell: (item) => {
      const statusFillColor = ["#F79009", "#17B26A", "#F04438"];
      const statusTextColor = ["#B54708", "#067647", "#B42318"];
      const Icon = () => (
        <CircleIcon
          fill={
            String(item?.row?.transactionStatus).toLowerCase() === "pending"
              ? statusFillColor[0]
              : String(item?.row?.transactionStatus).toLowerCase() ===
                "approved"
              ? statusFillColor[1]
              : statusFillColor[2]
          }
          style={{ marginRight: "8px", marginTop: "3px" }}
        />
      );
      return (
        <Box display={"flex"}>
          <Icon />
          <label
            style={{
              fontWeight: 500,
              fontSize: "14px",
              color:
                String(item?.row?.transactionStatus).toLowerCase() === "pending"
                  ? statusTextColor[0]
                  : String(item?.row?.transactionStatus).toLowerCase() ===
                    "approved"
                  ? statusTextColor[1]
                  : statusTextColor[2],
            }}
          >
            {item?.row?.transactionStatus || "--"}
          </label>
        </Box>
      );
    },
  },
  {
    id: 4,
    minWidth: 200,
    headerName: "Closing Date",
    field: "transactionClosingDate",
    fieldType: "date",
    displayPath: "closingDate",
    isDefaultFilterColumn: true,
    fieldKey: "closingDate",
    formFieldTitle: "Closing Date",
    disableColumnMenu: true,
    searchKey: "Closing Date",
    renderCell: (item) => (
      <label
        style={{
          fontWeight: 500,
          fontSize: "14px",
          color: isDarkMode ? "#F5F5F6" : "#101828",
        }}
      >
        {item?.row?.transactionClosingDate
          ? moment(item?.row?.transactionClosingDate).format("D MMM YYYY")
          : "--"}
      </label>
    ),
  },
  {
    id: 6,
    minWidth: 200,
    headerName: "Unit Number",
    field: "unitNumber",
    fieldType: "text",
    displayPath: "unitNumber",
    isDefaultFilterColumn: true,
    fieldKey: "unitNumber",
    formFieldTitle: "Unit Number",
    disableColumnMenu: true,
    searchKey: "Unit Number",
    renderCell: (item) => (
      <label
        style={{
          fontWeight: 500,
          fontSize: "14px",
          color: isDarkMode ? "#F5F5F6" : "#101828",
        }}
      >
        {item?.row?.unitNumber || "--"}
      </label>
    ),
  },
  {
    id: 5,
    minWidth: 200,
    headerName: "Unit Reference Number",
    field: "unitRefNumber",
    fieldType: "text",
    displayPath: "unitReferenceNumber",
    isDefaultFilterColumn: true,
    fieldKey: "unitReferenceNumber",
    formFieldTitle: "Unit Reference Number",
    disableColumnMenu: true,
    searchKey: "Unit Reference Number",
    renderCell: (item) => (
      <CustomCopyToClipboard
        data={item?.row?.unitRefNumber}
        childrenData={`#${item?.row?.unitRefNumber}`}
      />
    ),
  },

  {
    id: 7,
    minWidth: 200,
    headerName: "Property",
    field: "property",
    fieldType: "text",
    displayPath: "property",
    isDefaultFilterColumn: true,
    fieldKey: "property",
    formFieldTitle: "Property",
    disableColumnMenu: true,
    searchKey: "Property",
  },
  {
    id: 8,
    minWidth: 200,
    headerName: "Owner Name",
    field: "ownerName",
    fieldType: "text",
    displayPath: "ownerName",
    isDefaultFilterColumn: true,
    fieldKey: "ownerName",
    formFieldTitle: "Owner Name",
    disableColumnMenu: true,
    searchKey: "Owner Name",
    renderCell: (item) => (
      <label
        style={{
          fontWeight: 500,
          fontSize: "14px",
          color: isDarkMode ? "#F5F5F6" : "#101828",
        }}
      >
        {item?.row?.ownerName || "--"}
      </label>
    ),
  },
  {
    id: 9,
    minWidth: 200,
    headerName: "Deal Type",
    field: "dealType",
    fieldType: "text",
    displayPath: "dealType",
    isDefaultFilterColumn: true,
    fieldKey: "dealType",
    formFieldTitle: "Deal Type",
    disableColumnMenu: true,
    searchKey: "Deal Type",
  },
  {
    id: 29,
    minWidth: 200,
    headerName: "Property Value",
    field: "propertyValue",
    fieldType: "number",
    displayPath: "agencyFeesRate",
    isDefaultFilterColumn: true,
    fieldKey: "agencyFeesRate",
    formFieldTitle: "Agency Fees Rate",
    disableColumnMenu: true,
    searchKey: "Agency Fees Rate",
    renderCell: (item) => (
      <label
        style={{
          fontWeight: 500,
          fontSize: "14px",
          display: "flex",
          alignItems: "center",
          color: isDarkMode ? "#F5F5F6" : "#101828",
        }}
      >
        {typeof item?.row?.propertyValue === "number"
          ? `${formatNumberWithCommas(item.row.propertyValue)} `
          : "--"}
        {item?.row?.propertyValue ? (
          <AEDIcon
            width="14"
            height="14"
            aspect-ratio="1/1"
            fill={isDarkMode ? "#94969C" : "#475467"}
          />
        ) : (
          ""
        )}
      </label>
    ),
  },
  {
    id: 11,
    minWidth: 200,
    headerName: "Agency Fees Rate",
    field: "agencyFeesRate",
    fieldType: "number",
    displayPath: "agencyFeesRate",
    isDefaultFilterColumn: true,
    fieldKey: "agencyFeesRate",
    formFieldTitle: "Agency Fees Rate",
    disableColumnMenu: true,
    searchKey: "Agency Fees Rate",
    renderCell: (item) => (
      <label
        style={{
          fontWeight: 500,
          fontSize: "14px",
          color: isDarkMode ? "#F5F5F6" : "#101828",
        }}
      >
        {`${item?.row?.agencyFeesRate}%` || "--"}
      </label>
    ),
  },
  {
    id: 7865,
    minWidth: 200,
    headerName: "Total Agency fees",
    field: "totalAgencyFees",
    fieldType: "number",
    displayPath: "totalAgencyFees",
    isDefaultFilterColumn: true,
    fieldKey: "totalAgencyFees",
    formFieldTitle: "Total Agency Fees",
    disableColumnMenu: true,
    searchKey: "Total Agency Fees",
    renderCell: (item) => (
      <label
        style={{
          fontWeight: 500,
          fontSize: "14px",
          display: "flex",
          alignItems: "center",
          color: isDarkMode ? "#F5F5F6" : "#101828",
        }}
      >
        {typeof item?.row?.totalAgencyFees === "number"
          ? `${formatNumberWithCommas(item.row.totalAgencyFees)} `
          : "--"}
        {item?.row?.totalAgencyFees ? (
          <AEDIcon
            width="14"
            height="14"
            aspect-ratio="1/1"
            fill={isDarkMode ? "#94969C" : "#475467"}
          />
        ) : (
          ""
        )}
      </label>
    ),
  },
  {
    id: 12,
    minWidth: 200,
    headerName: "Total Deal Expenses",
    field: "totalDealExpense",
    fieldType: "number",
    displayPath: "totalDealExpenses",
    isDefaultFilterColumn: true,
    fieldKey: "totalDealExpenses",
    formFieldTitle: "Total Deal Expenses",
    disableColumnMenu: true,
    searchKey: "Total Deal Expenses",
    renderCell: (item) => (
      <label
        style={{
          fontWeight: 500,
          fontSize: "14px",
          display: "flex",
          alignItems: "center",
          color: isDarkMode ? "#F5F5F6" : "#101828",
        }}
      >
        {typeof item?.row?.totalDealExpense === "number"
          ? `${formatNumberWithCommas(item.row.totalDealExpense)} `
          : "--"}
        {typeof item?.row?.totalDealExpense === "number" ? (
          <AEDIcon
            width="14"
            height="14"
            aspect-ratio="1/1"
            fill={isDarkMode ? "#94969C" : "#475467"}
          />
        ) : (
          ""
        )}
      </label>
    ),
  },
  {
    id: 13,
    minWidth: 200,
    headerName: "Net Agency Fee",
    field: "netAgencyFee",
    fieldType: "number",
    displayPath: "netAgencyFee",
    isDefaultFilterColumn: true,
    fieldKey: "netAgencyFee",
    formFieldTitle: "Net Agency Fee",
    disableColumnMenu: true,
    searchKey: "Net Agency Fee",
    renderCell: (item) => (
      <label
        style={{
          fontWeight: 500,
          fontSize: "14px",
          display: "flex",
          alignItems: "center",
          color: isDarkMode ? "#F5F5F6" : "#101828",
        }}
      >
        {typeof item?.row?.netAgencyFee === "number"
          ? `${formatNumberWithCommas(item.row.netAgencyFee)} `
          : "--"}
        {typeof item?.row?.netAgencyFee === "number" ? (
          <AEDIcon
            width="14"
            height="14"
            aspect-ratio="1/1"
            fill={isDarkMode ? "#94969C" : "#475467"}
          />
        ) : (
          ""
        )}
      </label>
    ),
  },

  {
    id: 14,
    minWidth: 200,
    headerName: "Admin Fees",
    field: "adminFees",
    fieldType: "number",
    displayPath: "adminFees",
    isDefaultFilterColumn: true,
    fieldKey: "adminFees",
    formFieldTitle: "Admin Fees",
    disableColumnMenu: true,
    searchKey: "Admin Fees",
    renderCell: (item) => (
      <label
        style={{
          fontWeight: 500,
          fontSize: "14px",
          display: "flex",
          alignItems: "center",
          color: isDarkMode ? "#F5F5F6" : "#101828",
        }}
      >
        {typeof item?.row?.adminFees === "number"
          ? `${formatNumberWithCommas(item.row.adminFees)} `
          : "--"}
        {typeof item?.row?.adminFees === "number" ? (
          <AEDIcon
            width="14"
            height="14"
            aspect-ratio="1/1"
            fill={isDarkMode ? "#94969C" : "#475467"}
          />
        ) : (
          ""
        )}
      </label>
    ),
  },
  {
    id: 15,
    minWidth: 200,
    headerName: "Amount After Admin Fees",
    field: "amountAfterAdminFee",
    fieldType: "number",
    displayPath: "amountAfterAdminFees",
    isDefaultFilterColumn: true,
    fieldKey: "amountAfterAdminFees",
    formFieldTitle: "Amount After Admin Fees",
    disableColumnMenu: true,
    searchKey: "Amount After Admin Fees",
    renderCell: (item) => (
      <label
        style={{
          fontWeight: 500,
          fontSize: "14px",
          display: "flex",
          alignItems: "center",
          color: isDarkMode ? "#F5F5F6" : "#101828",
        }}
      >
        {typeof item?.row?.amountAfterAdminFee === "number"
          ? `${formatNumberWithCommas(item.row.amountAfterAdminFee)} `
          : "--"}
        {typeof item?.row?.amountAfterAdminFee === "number" ? (
          <AEDIcon
            width="14"
            height="14"
            aspect-ratio="1/1"
            fill={isDarkMode ? "#94969C" : "#475467"}
          />
        ) : (
          ""
        )}
      </label>
    ),
  },
  {
    id: 28,
    minWidth: 200,
    headerName: "Agent Commission Rate",
    field: "agentCommissionRate",
    fieldType: "number",
    displayPath: "agencyFeesRate",
    isDefaultFilterColumn: true,
    fieldKey: "agencyFeesRate",
    formFieldTitle: "Agency Fees Rate",
    disableColumnMenu: true,
    searchKey: "Agency Fees Rate",
    renderCell: (item) => (
      <label
        style={{
          fontWeight: 500,
          fontSize: "14px",
          color: isDarkMode ? "#F5F5F6" : "#101828",
        }}
      >
        {`${item?.row?.agentCommissionRate}%` || "--"}
      </label>
    ),
  },
  {
    id: 17,
    minWidth: 200,
    headerName: "Agent Commission",
    field: "agentCommission",
    fieldType: "number",
    displayPath: "agentCommission",
    isDefaultFilterColumn: true,
    fieldKey: "agentCommission",
    formFieldTitle: "Agent Commission",
    disableColumnMenu: true,
    searchKey: "Agent Commission",
    renderCell: (item) => (
      <label
        style={{
          fontWeight: 500,
          fontSize: "14px",
          display: "flex",
          alignItems: "center",
          color: isDarkMode ? "#F5F5F6" : "#101828",
        }}
      >
        {typeof item?.row?.agentCommission === "number"
          ? `${formatNumberWithCommas(item.row.agentCommission)} `
          : "--"}
        {typeof item?.row?.agentCommission === "number" ? (
          <AEDIcon
            width="14"
            height="14"
            aspect-ratio="1/1"
            fill={isDarkMode ? "#94969C" : "#475467"}
          />
        ) : (
          ""
        )}
      </label>
    ),
  },
  {
    id: 16,
    minWidth: 200,
    headerName: "Deduction Amount",
    field: "deduction",
    fieldType: "number",
    displayPath: "deductionAmount",
    isDefaultFilterColumn: true,
    fieldKey: "deductionAmount",
    formFieldTitle: "Deduction Amount",
    disableColumnMenu: true,
    searchKey: "Deduction Amount",
    renderCell: (item) => (
      <label
        style={{
          fontWeight: 500,
          fontSize: "14px",
          display: "flex",
          alignItems: "center",
          color: isDarkMode ? "#F5F5F6" : "#101828",
        }}
      >
        {typeof item?.row?.deduction === "number"
          ? `${formatNumberWithCommas(item.row.deduction)} `
          : "--"}
        {typeof item?.row?.deduction === "number" ? (
          <AEDIcon
            width="14"
            height="14"
            aspect-ratio="1/1"
            fill={isDarkMode ? "#94969C" : "#475467"}
          />
        ) : (
          ""
        )}
      </label>
    ),
  },

  {
    id: 18,
    minWidth: 210,
    headerName: " Commission After Deduction",
    field: "agentCommissionAfterDeduction",
    fieldType: "number",
    displayPath: "agentCommissionAfterDeduction",
    isDefaultFilterColumn: true,
    fieldKey: "agentCommissionAfterDeduction",
    formFieldTitle: "Agent Commission After Deduction",
    disableColumnMenu: true,
    searchKey: "Agent Commission After Deduction",
    renderCell: (item) => (
      <label
        style={{
          fontWeight: 500,
          fontSize: "14px",
          display: "flex",
          alignItems: "center",
          color: isDarkMode ? "#F5F5F6" : "#101828",
        }}
      >
        {typeof item?.row?.agentCommissionAfterDeduction === "number"
          ? `${formatNumberWithCommas(item.row.agentCommissionAfterDeduction)} `
          : "--"}
        {typeof item?.row?.agentCommissionAfterDeduction === "number" ? (
          <AEDIcon
            width="14"
            height="14"
            aspect-ratio="1/1"
            fill={isDarkMode ? "#94969C" : "#475467"}
          />
        ) : (
          ""
        )}
      </label>
    ),
  },
  {
    id: 19,
    minWidth: 200,
    headerName: "Listing Commission",
    field: "listingCommission",
    fieldType: "number",
    displayPath: "listingCommission",
    isDefaultFilterColumn: true,
    fieldKey: "listingCommission",
    formFieldTitle: "Listing Commission",
    disableColumnMenu: true,
    searchKey: "Listing Commission",
    renderCell: (item) => (
      <label
        style={{
          fontWeight: 500,
          fontSize: "14px",
          display: "flex",
          alignItems: "center",
          color: isDarkMode ? "#F5F5F6" : "#101828",
        }}
      >
        {typeof item?.row?.listingCommission === "number"
          ? `${formatNumberWithCommas(item.row.listingCommission)} `
          : "--"}
        {typeof item?.row?.listingCommission === "number" ? (
          <AEDIcon
            width="14"
            height="14"
            aspect-ratio="1/1"
            fill={isDarkMode ? "#94969C" : "#475467"}
          />
        ) : (
          ""
        )}
      </label>
    ),
  },
  {
    id: 20,
    minWidth: 200,
    headerName: "Telesales Commission",
    field: "telesalesCommission",
    fieldType: "number",
    displayPath: "telesalesCommission",
    isDefaultFilterColumn: true,
    fieldKey: "telesalesCommission",
    formFieldTitle: "Telesales Commission",
    disableColumnMenu: true,
    searchKey: "Telesales Commission",
    renderCell: (item) => (
      <label
        style={{
          fontWeight: 500,
          fontSize: "14px",
          display: "flex",
          alignItems: "center",
          color: isDarkMode ? "#F5F5F6" : "#101828",
        }}
      >
        {typeof item?.row?.telesalesCommission === "number"
          ? `${formatNumberWithCommas(item.row.telesalesCommission)} `
          : "--"}
        {typeof item?.row?.telesalesCommission === "number" ? (
          <AEDIcon
            width="14"
            height="14"
            aspect-ratio="1/1"
            fill={isDarkMode ? "#94969C" : "#475467"}
          />
        ) : (
          ""
        )}
      </label>
    ),
  },
  {
    id: 21,
    minWidth: 200,
    headerName: "Coordinator Commission",
    field: "coordinatorCommission",
    fieldType: "number",
    displayPath: "coordinatorCommission",
    isDefaultFilterColumn: true,
    fieldKey: "coordinatorCommission",
    formFieldTitle: "Coordinator Commission",
    disableColumnMenu: true,
    searchKey: "Coordinator Commission",
    renderCell: (item) => (
      <label
        style={{
          fontWeight: 500,
          fontSize: "14px",
          display: "flex",
          alignItems: "center",
          color: isDarkMode ? "#F5F5F6" : "#101828",
        }}
      >
        {typeof item?.row?.coordinatorCommission === "number"
          ? `${formatNumberWithCommas(item.row.coordinatorCommission)} `
          : "--"}
        {typeof item?.row?.coordinatorCommission === "number" ? (
          <AEDIcon
            width="14"
            height="14"
            aspect-ratio="1/1"
            fill={isDarkMode ? "#94969C" : "#475467"}
          />
        ) : (
          ""
        )}
      </label>
    ),
  },
  {
    id: 22,
    minWidth: 200,
    headerName: "Net Amount Before TL & SM",
    field: "netAmountBeforeTlAndSm",
    fieldType: "number",
    displayPath: "netAmountBeforeTLSM",
    isDefaultFilterColumn: true,
    fieldKey: "netAmountBeforeTLSM",
    formFieldTitle: "Net Amount Before TL & SM",
    disableColumnMenu: true,
    searchKey: "Net Amount Before TL & SM",
    renderCell: (item) => (
      <label
        style={{
          fontWeight: 500,
          fontSize: "14px",
          display: "flex",
          alignItems: "center",
          color: isDarkMode ? "#F5F5F6" : "#101828",
        }}
      >
        {typeof item?.row?.netAmountBeforeTlAndSm === "number"
          ? `${formatNumberWithCommas(item.row.netAmountBeforeTlAndSm)} `
          : "--"}
        {typeof item?.row?.netAmountBeforeTlAndSm === "number" ? (
          <AEDIcon
            width="14"
            height="14"
            aspect-ratio="1/1"
            fill={isDarkMode ? "#94969C" : "#475467"}
          />
        ) : (
          ""
        )}
      </label>
    ),
  },
  {
    id: 23,
    minWidth: 200,
    headerName: "TL Commission Rate",
    field: "tlCommissionRate",
    fieldType: "number",
    displayPath: "tlCommissionRate",
    isDefaultFilterColumn: true,
    fieldKey: "tlCommissionRate",
    formFieldTitle: "TL Commission Rate",
    disableColumnMenu: true,
    searchKey: "TL Commission Rate",
    renderCell: (item) => (
      <label
        style={{
          fontWeight: 500,
          fontSize: "14px",
          display: "flex",
          alignItems: "center",
          color: isDarkMode ? "#F5F5F6" : "#101828",
        }}
      >
        {`${item?.row?.tlCommissionRate}%` || "--"}
      </label>
    ),
  },
  {
    id: 24,
    minWidth: 200,
    headerName: "TL Commission Amount",
    field: "tlCommissionAmount",
    fieldType: "number",
    displayPath: "tlCommissionAmount",
    isDefaultFilterColumn: true,
    fieldKey: "tlCommissionAmount",
    formFieldTitle: "TL Commission Amount",
    disableColumnMenu: true,
    searchKey: "TL Commission Amount",
    renderCell: (item) => (
      <label
        style={{
          fontWeight: 500,
          fontSize: "14px",
          display: "flex",
          alignItems: "center",
          color: isDarkMode ? "#F5F5F6" : "#101828",
        }}
      >
        {typeof item?.row?.tlCommissionAmount === "number"
          ? `${formatNumberWithCommas(item.row.tlCommissionAmount)} `
          : "--"}
        {typeof item?.row?.tlCommissionAmount === "number" ? (
          <AEDIcon
            width="14"
            height="14"
            aspect-ratio="1/1"
            fill={isDarkMode ? "#94969C" : "#475467"}
          />
        ) : (
          ""
        )}
      </label>
    ),
  },
  {
    id: 25,
    minWidth: 200,
    headerName: "SM Commission Rate",
    field: "smCommissionRate",
    fieldType: "number",
    displayPath: "smCommissionRate",
    isDefaultFilterColumn: true,
    fieldKey: "smCommissionRate",
    formFieldTitle: "SM Commission Rate",
    disableColumnMenu: true,
    searchKey: "SM Commission Rate",
    renderCell: (item) => (
      <label
        style={{
          fontWeight: 500,
          fontSize: "14px",
          display: "flex",
          alignItems: "center",
          color: isDarkMode ? "#F5F5F6" : "#101828",
        }}
      >
        {`${item?.row?.smCommissionRate}%` || "--"}
      </label>
    ),
  },
  {
    id: 26,
    minWidth: 200,
    headerName: "SM Commission Amount",
    field: "smCommissionAmount",
    fieldType: "number",
    displayPath: "smCommissionAmount",
    isDefaultFilterColumn: true,
    fieldKey: "smCommissionAmount",
    formFieldTitle: "SM Commission Amount",
    disableColumnMenu: true,
    searchKey: "SM Commission Amount",
    renderCell: (item) => (
      <label
        style={{
          fontWeight: 500,
          fontSize: "14px",
          display: "flex",
          alignItems: "center",
          color: isDarkMode ? "#F5F5F6" : "#101828",
        }}
      >
        {typeof item?.row?.smCommissionAmount === "number"
          ? `${formatNumberWithCommas(item.row.smCommissionAmount)} `
          : "--"}
        {typeof item?.row?.smCommissionAmount === "number" ? (
          <AEDIcon
            width="14"
            height="14"
            aspect-ratio="1/1"
            fill={isDarkMode ? "#94969C" : "#475467"}
          />
        ) : (
          ""
        )}
      </label>
    ),
  },
  {
    id: 27,
    minWidth: 200,
    headerName: "Final Net Amount",
    field: "finalNetAmount",
    fieldType: "number",
    displayPath: "finalNetAmount",
    isDefaultFilterColumn: true,
    fieldKey: "finalNetAmount",
    formFieldTitle: "Final Net Amount",
    disableColumnMenu: true,
    searchKey: "Final Net Amount",
    renderCell: (item) => (
      <label
        style={{
          fontWeight: 500,
          fontSize: "14px",
          display: "flex",
          alignItems: "center",
          color: isDarkMode ? "#F5F5F6" : "#101828",
        }}
      >
        {typeof item?.row?.finalNetAmount === "number"
          ? `${formatNumberWithCommas(item.row.finalNetAmount)} `
          : "--"}
        {typeof item?.row?.finalNetAmount === "number" ? (
          <AEDIcon
            width="14"
            height="14"
            aspect-ratio="1/1"
            fill={isDarkMode ? "#94969C" : "#475467"}
          />
        ) : (
          ""
        )}
      </label>
    ),
  },
];
export const CommissionTableNestedHeaderData = ({ isDarkMode = false }) => [
  { id: 1, headerName: "Invoices Number", field: "invoicesNumber" },
  { id: 2, headerName: "Voucher Number", field: "voucherNumber" },
  {
    id: 3,
    headerName: "Invoice Status",
    field: "invoiceStatus",
    renderCell: (item) => {
      // Example: "Submitted" (green), "Not Ready" (gray)
      const value = item?.invoiceStatus === 1 ? "Submitted" : "Not Ready";
      let color = "#B54708";
      if (value === "Submitted") color = "#067647";
      const fillColor = value === "Submitted" ? "#17B26A" : "#B54708";
      return (
        <span style={{ display: "flex", alignItems: "center" }}>
          <CircleIcon
            fill={fillColor}
            style={{ marginRight: "8px", marginTop: "3px" }}
          />
          <span style={{ color, fontWeight: 500 }}>{value || "N/A"}</span>
        </span>
      );
    },
  },
  {
    id: 4,
    headerName: "Collection Status",
    field: "collectionStatus",
    renderCell: (item) => {
      // Example: "Paid" (green), "Unpaid" (red)
      const value = item?.collectionStatus === 1 ? "Paid" : "Unpaid";
      let color = "#F04438";
      if (value === "Paid") color = "#067647";
      const fillColor = value === "Paid" ? "#17B26A" : "#F04438";
      return (
        <span style={{ display: "flex", alignItems: "center" }}>
          <CircleIcon
            fill={fillColor}
            style={{ marginRight: "8px", marginTop: "3px" }}
          />
          <span style={{ color, fontWeight: 500 }}>{value || "N/A"}</span>
        </span>
      );
    },
  },
  {
    id: 5,
    headerName: "Payment Status",
    field: "paymentStatus",
    renderCell: (item) => {
      const value =
        item.paymentStatus === 1
          ? "Pending"
          : item.paymentStatus === 2
          ? "Ready to Released"
          : "Released ";
      let color = "#B54708";
      let fillColor = "#F79009";
      if (value === "Ready to Released") {
        color = "#175CD3";
        fillColor = "#2E90FA";
      }
      if (value === "Released") {
        color = "#17B26A";
        fillColor = "#17B26A";
      }
      return (
        <span style={{ display: "flex", alignItems: "center" }}>
          <CircleIcon
            fill={fillColor}
            style={{ marginRight: "8px", marginTop: "3px" }}
          />
          <span style={{ color, fontWeight: 500 }}>{value || "N/A"}</span>
        </span>
      );
    },
  },
  {
    id: 6,
    headerName: "Property Value",
    field: "propertyValue",
    renderCell: (item) => {
      let value = item?.propertyValue;
      typeof value === "number"
        ? (value = (
            <span
              style={{ fontWeight: 500, display: "flex", alignItems: "center" }}
            >
              {formatNumberWithCommas(value)}{" "}
              <AEDIcon
                width="14"
                height="14"
                aspect-ratio="1/1"
                fill={isDarkMode ? "#94969C" : "#475467"}
              />
            </span>
          ))
        : (value = "N/A");
      return <span>{value}</span>;
    },
  },
  {
    id: 7,
    headerName: "Agency Fees Rate",
    field: "agencyFeesRate",
    renderCell: (item) => {
      const value = item.agencyFeesRate;
      if (typeof value !== "number")
        return <span style={{ fontWeight: 500 }}>N/A</span>;

      return <span style={{ fontWeight: 500 }}>{`${value}%`}</span>;
    },
  },
  {
    id: 8,
    headerName: "Total Agency Fees",
    field: "totalAgencyFees",
    renderCell: (item) => {
      let value = item?.totalAgencyFees;
      typeof value === "number"
        ? (value = (
            <span
              style={{ fontWeight: 500, display: "flex", alignItems: "center" }}
            >
              {formatNumberWithCommas(value)}{" "}
              <AEDIcon
                width="14"
                height="14"
                aspect-ratio="1/1"
                fill={isDarkMode ? "#94969C" : "#475467"}
              />
            </span>
          ))
        : (value = "N/A");
      return <span>{value}</span>;
    },
  },
  {
    id: 9,
    headerName: "Total Deal Expense",
    field: "totalDealExpense",
    renderCell: (item) => {
      let value = item?.totalDealExpense;
      typeof value === "number"
        ? (value = (
            <span
              style={{ fontWeight: 500, display: "flex", alignItems: "center" }}
            >
              {formatNumberWithCommas(value)}{" "}
              <AEDIcon
                width="14"
                height="14"
                aspect-ratio="1/1"
                fill={isDarkMode ? "#94969C" : "#475467"}
              />
            </span>
          ))
        : (value = "N/A");
      return <span>{value}</span>;
    },
  },
  {
    id: 10,
    headerName: "Net Agency Fee",
    field: "netAgencyFee",
    renderCell: (item) => {
      let value = item?.netAgencyFee;
      typeof value === "number"
        ? (value = (
            <span
              style={{ fontWeight: 500, display: "flex", alignItems: "center" }}
            >
              {formatNumberWithCommas(value)}{" "}
              <AEDIcon
                width="14"
                height="14"
                aspect-ratio="1/1"
                fill={isDarkMode ? "#94969C" : "#475467"}
              />
            </span>
          ))
        : (value = "N/A");
      return <span>{value}</span>;
    },
  },
  {
    id: 11,
    headerName: "Admin Fees",
    field: "adminFees",
    renderCell: (item) => {
      let value = item?.adminFees;
      typeof value === "number"
        ? (value = (
            <span
              style={{ fontWeight: 500, display: "flex", alignItems: "center" }}
            >
              {formatNumberWithCommas(value)}{" "}
              <AEDIcon
                width="14"
                height="14"
                aspect-ratio="1/1"
                fill={isDarkMode ? "#94969C" : "#475467"}
              />
            </span>
          ))
        : (value = "N/A");
      return <span>{value}</span>;
    },
  },
  {
    id: 12,
    headerName: "Amount after Admin Fees",
    field: "amountAfterAdminFees",
    renderCell: (item) => {
      let value = item?.amountAfterAdminFees;
      typeof value === "number"
        ? (value = (
            <span
              style={{ fontWeight: 500, display: "flex", alignItems: "center" }}
            >
              {formatNumberWithCommas(value)}{" "}
              <AEDIcon
                width="14"
                height="14"
                aspect-ratio="1/1"
                fill={isDarkMode ? "#94969C" : "#475467"}
              />
            </span>
          ))
        : (value = "N/A");
      return <span>{value}</span>;
    },
  },
  {
    id: 13,
    headerName: "Agent Commission Rate",
    field: "agentCommissionRate",
    renderCell: (item) => {
      const value = item?.agentCommissionRate;
      if (typeof value !== "number")
        return <span style={{ fontWeight: 500 }}>N/A</span>;

      return <span style={{ fontWeight: 500 }}>{`${value}%`}</span>;
    },
  },
  {
    id: 14,
    headerName: "Agent Commission",
    field: "agentCommission",
    renderCell: (item) => {
      let value = item?.agentCommission;
      typeof value === "number"
        ? (value = (
            <span
              style={{ fontWeight: 500, display: "flex", alignItems: "center" }}
            >
              {formatNumberWithCommas(value)}{" "}
              <AEDIcon
                width="14"
                height="14"
                aspect-ratio="1/1"
                fill={isDarkMode ? "#94969C" : "#475467"}
              />
            </span>
          ))
        : (value = "N/A");
      return <span>{value}</span>;
    },
  },
  {
    id: 15,
    headerName: "Listing Commission",
    field: "listingCommission",
    renderCell: (item) => {
      let value = item?.listingCommission;
      typeof value === "number"
        ? (value = (
            <span
              style={{ fontWeight: 500, display: "flex", alignItems: "center" }}
            >
              {formatNumberWithCommas(value)}{" "}
              <AEDIcon
                width="14"
                height="14"
                aspect-ratio="1/1"
                fill={isDarkMode ? "#94969C" : "#475467"}
              />
            </span>
          ))
        : (value = "N/A");
      return <span>{value}</span>;
    },
  },
  {
    id: 16,
    headerName: "Deduction",
    field: "deduction",
    renderCell: (item) => {
      let value = item?.deduction;
      typeof value === "number"
        ? (value = (
            <span
              style={{
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                color: isDarkMode ? "#F97066" : "#D92D20",
              }}
            >
              {formatNumberWithCommas(value * -1)}{" "}
              <AEDIcon
                width="14"
                height="14"
                aspect-ratio="1/1"
                fill={isDarkMode ? "#F97066" : "#D92D20"}
              />
            </span>
          ))
        : (value = "N/A");
      return <span>{value}</span>;
    },
  },
  {
    id: 17,
    headerName: "Commission After Deduction",
    field: "agentCommissionAfterDeduction",
    renderCell: (item) => {
      let value = item?.agentCommissionAfterDeduction;
      typeof value === "number"
        ? (value = (
            <span
              style={{ fontWeight: 500, display: "flex", alignItems: "center" }}
            >
              {formatNumberWithCommas(value)}{" "}
              <AEDIcon
                width="14"
                height="14"
                aspect-ratio="1/1"
                fill={isDarkMode ? "#94969C" : "#475467"}
              />
            </span>
          ))
        : (value = "N/A");
      return <span>{value}</span>;
    },
  },
  {
    id: 18,
    headerName: "Listing Commission",
    field: "listingCommission",
    renderCell: (item) => {
      let value = item?.listingCommission;
      typeof value === "number"
        ? (value = (
            <span
              style={{ fontWeight: 500, display: "flex", alignItems: "center" }}
            >
              {formatNumberWithCommas(value)}{" "}
              <AEDIcon
                width="14"
                height="14"
                aspect-ratio="1/1"
                fill={isDarkMode ? "#94969C" : "#475467"}
              />
            </span>
          ))
        : (value = "N/A");
      return <span>{value}</span>;
    },
  },
  {
    id: 19,
    headerName: "Telesales Commission",
    field: "telesalesCommission",
    renderCell: (item) => {
      let value = item?.telesalesCommission;
      typeof value === "number"
        ? (value = (
            <span
              style={{ fontWeight: 500, display: "flex", alignItems: "center" }}
            >
              {formatNumberWithCommas(value)}{" "}
              <AEDIcon
                width="14"
                height="14"
                aspect-ratio="1/1"
                fill={isDarkMode ? "#94969C" : "#475467"}
              />
            </span>
          ))
        : (value = "N/A");
      return <span>{value}</span>;
    },
  },
  {
    id: 20,
    headerName: "Coordinator Commission",
    field: "coordinatorCommission",
    renderCell: (item) => {
      let value = item?.coordinatorCommission;
      typeof value === "number"
        ? (value = (
            <span
              style={{ fontWeight: 500, display: "flex", alignItems: "center" }}
            >
              {formatNumberWithCommas(value)}{" "}
              <AEDIcon
                width="14"
                height="14"
                aspect-ratio="1/1"
                fill={isDarkMode ? "#94969C" : "#475467"}
              />
            </span>
          ))
        : (value = "N/A");
      return <span>{value}</span>;
    },
  },
  {
    id: 21,
    headerName: "Net Amount Before TL & SM",
    field: "netAmountBeforeTlAndSm",
    renderCell: (item) => {
      let value = item?.netAmountBeforeTlAndSm;
      typeof value === "number"
        ? (value = (
            <span
              style={{ fontWeight: 500, display: "flex", alignItems: "center" }}
            >
              {formatNumberWithCommas(value)}{" "}
              <AEDIcon
                width="14"
                height="14"
                aspect-ratio="1/1"
                fill={isDarkMode ? "#94969C" : "#475467"}
              />
            </span>
          ))
        : (value = "N/A");
      return <span>{value}</span>;
    },
  },
  {
    id: 22,
    headerName: "TL Commission Rate",
    field: "tlCommissionRate",
    renderCell: (item) => {
      let value = item?.tlCommissionRate;
      if (typeof value !== "number")
        return <span style={{ fontWeight: 500 }}>N/A</span>;
      return <span style={{ fontWeight: 500 }}>{`${value}%`}</span>;
    },
  },
  {
    id: 23,
    headerName: "TL Commission Amount",
    field: "tlCommissionAmount",
    renderCell: (item) => {
      let value = item?.tlCommissionAmount;
      typeof value === "number"
        ? (value = (
            <span
              style={{ fontWeight: 500, display: "flex", alignItems: "center" }}
            >
              {formatNumberWithCommas(value)}{" "}
              <AEDIcon
                width="14"
                height="14"
                aspect-ratio="1/1"
                fill={isDarkMode ? "#94969C" : "#475467"}
              />
            </span>
          ))
        : (value = "N/A");
      return <span>{value}</span>;
    },
  },
  {
    id: 24,
    headerName: "SM Commission Rate",
    field: "smCommissionRate",
    renderCell: (item) => {
      let value = item?.smCommissionRate;
      if (typeof value !== "number")
        return <span style={{ fontWeight: 500 }}>N/A</span>;
      return <span style={{ fontWeight: 500 }}>{`${value}%`}</span>;
    },
  },
  {
    id: 25,
    headerName: "SM Commission Amount",
    field: "smCommissionAmount",
    renderCell: (item) => {
      let value = item?.smCommissionAmount;
      typeof value === "number"
        ? (value = (
            <span
              style={{ fontWeight: 500, display: "flex", alignItems: "center" }}
            >
              {formatNumberWithCommas(value)}{" "}
              <AEDIcon
                width="14"
                height="14"
                aspect-ratio="1/1"
                fill={isDarkMode ? "#94969C" : "#475467"}
              />
            </span>
          ))
        : (value = "N/A");
      return <span>{value}</span>;
    },
  },
  {
    id: 26,
    headerName: "Final Net Amount",
    field: "finalNetAmount",
    renderCell: (item) => {
      let value = item?.finalNetAmount;
      typeof value === "number"
        ? (value = (
            <span
              style={{ fontWeight: 500, display: "flex", alignItems: "center" }}
            >
              {formatNumberWithCommas(value)}{" "}
              <AEDIcon
                width="14"
                height="14"
                aspect-ratio="1/1"
                fill={isDarkMode ? "#94969C" : "#475467"}
              />
            </span>
          ))
        : (value = "N/A");
      return <span>{value}</span>;
    },
  },
];

export default CommissionTableHeaderData;
